export default "__VITE_ASSET__DLoS13M5__"